<template>
    <b-container>
        <template v-if="$options.components['advertisement-loading']">
            <advertisement-loading v-if="isLoading" />
        </template>
      <b-row v-if="!isLoading">
        <b-col class="my-4">
          <div class="main-banner">
            <img
              :src="
                (physiotherapistBanner.icon && physiotherapistBanner.icon.fileUrl) || ''
              "
              alt="Physiotherapist Center Top Banner"
            />
          </div>
          <div>
            <b-row class="my-4">
              <b-col
                md="4"
                v-for="physio in physiotherapistCategory"
                :key="physio.category"
              >
                <div
                  @click="physioCategoryClick(physio.category)"
                  class="physio-category"
                  :style="{
                    backgroundImage: 'url(' + physio.backgroundImage + ')',
                  }"
                >
                  <p>{{ physio.category }}</p>
                </div>
              </b-col>
            </b-row>
          </div>

          <div>
            <b-container>
              <template v-if="$options.components['advertisement-bottom-banner']">
                <advertisement-bottom-banner />
              </template>
            </b-container>
          </div>

          <div class="main-banner">
            <img
              :src="
                (physiotherapistBanner.icon && physiotherapistBanner.icon.fileUrl) || ''
              "
              alt="Diagnostic Center Top Banner"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        isLoading: false,
        physiotherapistCategory: [
          { category: "Orthopedic", backgroundImage: "/public/img/Add.png" },
          { category: "Geriatric", backgroundImage: "/public/img/Add.png" },
          { category: "Neurological", backgroundImage: "/public/img/Add.png" },
          { category: "CardioPulmonary", backgroundImage: "/public/img/Add.png" },
          { category: "Pediatric", backgroundImage: "/public/img/Add.png" },
          { category: "Vestibular Rehabilitation", backgroundImage: "/public/img/Add.png" },
          { category: "Women's Health", backgroundImage: "/public/img/Add.png" },
        ],
      };
    },
  
    computed: {
      ...mapState({
        physiotherapistBanner: (state) => state.healthCare.marketBanner,
      }),
    },
  
    methods: {
      physioCategoryClick(physioCategory) {
        if (physioCategory === "") {
          this.$router.push({ name: "" });
        } else {
          this.$router.push({ name: "" });
        }
      },
    },
  
    async mounted() {
      this.isLoading = true;
      let payload = {
        city: "GHATAL",
        placement: "DIAGONOSTICS_TOP",
      };
      await this.$store.dispatch("healthCare/fetchMarketBanner", payload);
  
      this.isLoading = false;
    },
  };
  </script>
  
  <style scoped>
  .physio-category {
    display: flex;
    align-items: center;
    height: 100px;
    padding-left: 8px;
    color: #ffffff;
    background: blue url(/public/img/Add.png) no-repeat scroll 0px 0px;
    cursor: pointer;
  }
  </style>
  